import React from 'react'
import { useBiometricsStatus } from '@mobi/account/Areas/Verification/Biometrics/Hooks/useBiometricsStatus'
import { store } from '@core/Store'
import {
  updateUserBiometricsOnDataLayer,
  updateUserSettingsOnDataLayer,
} from '../helpers/dataLayer/updaters'

/** Initialises and keeps data layer user info updated */
export const useInitAnalyticsDataLayer = () => {
  const { isBiometricsStatusReady, isBiometricsEnabled } = useBiometricsStatus()

  React.useEffect(() => {
    if (!isBiometricsStatusReady) return
    updateUserBiometricsOnDataLayer(isBiometricsEnabled)
  }, [isBiometricsStatusReady, isBiometricsEnabled])

  React.useEffect(() => {
    updateAnalyticsDataLayer()
  }, [])
}

// =============
// Local Helpers
// =============

async function updateAnalyticsDataLayer() {
  const appState = store.getState()
  updateUserSettingsOnDataLayer(appState)
}
